<ion-content>
  <app-header [isParentPage]="false" [title]="'Custom Report Admin'"></app-header>

  <div class="loading-container" style="padding-top:13%;" *ngIf="!loading">
    <ion-spinner></ion-spinner>
  </div>
   
   <div class="table-container" >
     <ion-row> <ion-button  style="float:right; margin-bottom:5px;padding-left:80%" color="gallaghergreen" (click)="addNewRecord()">Add a new record</ion-button>
     </ion-row>
    <ion-row>
          <div class="table-row">
            <ngx-datatable
              class="bootstrap"
              [rows]="customerSiteReports"
              [rowHeight]="50"
              [sortType]="'multi'"
              [headerHeight]="50"
              [footerHeight]="50"
              [columnMode]="'force'"
              [scrollbarH]="false"
            >
             <ngx-datatable-column name="Action" >
              <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
                <span style="padding-right:10px">
                  <a (click)="editCustomSiteReport(row.id)" class="link">
                    <ion-icon name="create-outline"></ion-icon>
                  </a>
                </span>

                <span style="padding-right:10px">
                  <a (click)="deleteCustomSiteReport(row.id)" class="link">
                    <ion-icon name="trash-outline"></ion-icon>
                  </a>
                </span>

                <span>
                  <a (click)="viewCustomerReports(row)" class="link">
                    <ion-icon name="eye-outline"></ion-icon>
                  </a>
                </span>
              </ng-template>
            </ngx-datatable-column>
              <ngx-datatable-column name="Short Name" prop="shortName">
              <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
                {{value }}
              </ng-template>
            </ngx-datatable-column>
              <ngx-datatable-column name="Category" prop="category">
              <ng-template ngx-datatable-cell-template let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
              <ngx-datatable-column name="Access By" prop="accessLevel">
              <ng-template ngx-datatable-cell-template let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
             <ngx-datatable-column name="Report Type" prop="reportType">
              <ng-template ngx-datatable-cell-template let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </ion-row>
        </div>
</ion-content>
